export  const CheckIncustomerConstant = {
    CHECKIN_CUSTOMER_SAGA: "CHECKIN_CUSTOMER_SAGA",
    CHECKIN_CUSTOMER_REQUEST: "CHECKIN_CUSTOMER_REQUEST",
    CHECKIN_CUSTOMER_RESPONSE: "CHECKIN_CUSTOMER_RESPONSE",
    CHECKIN_CUSTOMER_API: "/get-customers",

    ADD_CHECKIN_CUSTOMER_DETAIL_SAGA: "ADD_CHECKIN_CUSTOMER_DETAIL_SAGA",
    ADD_CHECKIN_CUSTOMER_DETAIL_REQUEST: "ADD_CHECKIN_CUSTOMER_DETAIL_REQUEST",
    ADD_CHECKIN_CUSTOMER_DETAIL_RESPONSE: "ADD_CHECKIN_CUSTOMER_DETAIL_RESPONSE",
    ADD_CHECKIN_CUSTOMER_DETAIL_API: "/add-details",
   
    CHECKIN_CUSTOMER_DETAILS_BY_ID_SAGA: "CHECKIN_CUSTOMER_DETAILS_BY_ID_SAGA",
    CHECKIN_CUSTOMER_DETAILS_BY_ID_REQUEST: "CHECKIN_CUSTOMER_DETAILS_BY_ID_REQUEST",
    CHECKIN_CUSTOMER_DETAILS_BY_ID_RESPONSE: "CHECKIN_CUSTOMER_DETAILS_BY_ID_RESPONSE",
    CHECKIN_CUSTOMER_DETAILS_BY_ID_API: "/get-checkin-by-customer",

    CHECKIN_SEARCH_HISTORY_BY_ID_SAGA: "CHECKIN_SEARCH_HISTORY_BY_ID_SAGA",
    CHECKIN_SEARCH_HISTORY_BY_ID_REQUEST: "CHECKIN_SEARCH_HISTORY_BY_ID_REQUEST",
    CHECKIN_SEARCH_HISTORY_BY_ID_RESPONSE: "CHECKIN_SEARCH_HISTORY_BY_ID_RESPONSE",
    CHECKIN_SEARCH_HISTORY_BY_ID_API: "/search-history",

    CHECKIN_CHARGING_HISTORY_BY_ID_API: "/get-charging-history",


    CHECKIN_SEARCH_NAVIGATION_BY_ID_SAGA: "CHECKIN_SEARCH_NAVIGATION_BY_ID_SAGA",
    CHECKIN_SEARCH_NAVIGATION_BY_ID_REQUEST: "CHECKIN_SEARCH_NAVIGATION_BY_ID_REQUEST",
    CHECKIN_SEARCH_NAVIGATION_BY_ID_RESPONSE: "CHECKIN_SEARCH_NAVIGATION_BY_ID_RESPONSE",
    CHECKIN_SEARCH_NAVIGATION_BY_ID_API: "/get-navigation",

    CHECKIN_VEHICLE_BY_ID_SAGA: "CHECKIN_VEHICLE_BY_ID_SAGA",
    CHECKIN_VEHICLE_BY_ID_REQUEST: "CHECKIN_VEHICLE_BY_ID_REQUEST",
    CHECKIN_VEHICLE_BY_ID_RESPONSE: "CHECKIN_VEHICLE_BY_ID_RESPONSE",
    CHECKIN_VEHICLE_BY_ID_API: "/vehicles",
   
    CUSTOMER_DETAILS_BY_ID_SAGA: "CUSTOMER_DETAILS_BY_ID_SAGA",
    CUSTOMER_DETAILS_BY_ID_REQUEST: "CUSTOMER_DETAILS_BY_ID_REQUEST",
    CUSTOMER_DETAILS_BY_ID_RESPONSE: "CUSTOMER_DETAILS_BY_ID_RESPONSE",
    CUSTOMER_DETAILS_BY_ID_API: "/customer",

  };
  